<template>
  <card-info>
    <div class="row">
      <div class="col-10 col-md-5 col-lg-4 col-xl-3 mx-auto mt-5">
        <card>
          <br />
          <fg-input
            type="tel"
            label="Номер телефона"
            v-model="phone"
                     v-mask="'+998#########'"
            placeholder="+998"

          ></fg-input>
          <fg-input
            type="password"
            label="Пароль"
            v-model="password"
            placeholder="Введите пароль"
          ></fg-input>
          <br />
          <p-button
            class="w-100 mb-3"
            type="warning"
            round
            @click.native.prevent="login"
            >Войти в систему</p-button
          >
        </card>
      </div>
    </div>
  </card-info>
</template>

<script>
import { errorNotify } from "../plugins/functions";

export default {
  name: "login",
  components: {},
  mounted() {},
  data() {
    return {
      phone: "",
      password: "",
    };
  },
  methods: {
    login(loading = true) {
      this.$loading(true);
      this.$http
        .post("login", {
          phone: this.phone,
          password: this.password,
        })
        .then((response) => {
          
          this.$http.defaults.headers.common["Authorization"] =
            "Bearer " + response.data.access.accessToken;

          localStorage.setItem(
            "token",
            "Bearer " + response.data.access.accessToken
          );

          this.$store.dispatch("setUser", response.data);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
